import * as tslib_1 from "tslib";
import { makePostRequest } from 'owa-ows-gateway';
var GET_SHARING_LINK_INFO_URL = 'ows/api/beta/sharinglink/info';
export function getSharingLinkInfo(link, returnRawResponse) {
    if (returnRawResponse === void 0) { returnRawResponse = false; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makePostRequest(GET_SHARING_LINK_INFO_URL, { url: link }, undefined /* correlationId */, returnRawResponse)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=getSharingLinkInfo.js.map